<template>
    <thead class="bg-gray-50">
    <tr>
        <th scope="col" class="lg:hidden table-cell py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">Zpráva</th>

        <th v-if="type === 'inbox'" scope="col" class="hidden lg:table-cell py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">Odesílatel</th>
        <th v-if="type === 'sent' || type === 'drafts'" scope="col" class="hidden lg:table-cell py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">Adresát</th>
        <th v-if="type === 'trash'" scope="col" class="hidden lg:table-cell py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">Adresát/Odesílatel</th>

        <th scope="col" class="hidden lg:table-cell px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Předmět</th>

        <th v-if="type === 'sent' || type === 'trash'" scope="col" class="hidden lg:table-cell px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Stav</th>

        <th scope="col" class="hidden sm:table-cell px-3 py-3.5 text-left text-sm font-semibold text-gray-900 text-right">Datum</th>
        <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6 w-2">
            <span class="sr-only">Edit</span>
        </th>
    </tr>
    </thead>
</template>

<script>
export default {
    name: "MessagesTableHeader",
    props: ['type'],

}
</script>

<style scoped>

</style>
